const request = require("request");
const config = require("./config");

const getAllFornecedoresGrupo = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          "Content-Type": "application/json",
          "User-Token": token,
        },
        uri: `${config.URL_BACKEND}/fornecedoresGrupo`,
        method: "GET",
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

var PostFornecedoresGrupo = (token, obj) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          "Content-Type": "application/json",
          "User-Token": token,
        },
        timeout: 2500,
        uri: `${config.URL_BACKEND}/fornecedoresGrupo`,
        method: "POST",
        body: obj,
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

module.exports = {
  getAllFornecedoresGrupo: getAllFornecedoresGrupo,
  PostFornecedoresGrupo: PostFornecedoresGrupo,
};
